import { LitElement, html, css, unsafeHTML } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js'

/**
 * Skio Universal Plan Picker
 * @docs https://integrate.skio.com/
 *
 * Uses LitJS (<5kb) https://lit.dev/ for reactive web components
 */

export class SkioPlanPicker extends LitElement {
  static properties = {
    key: { type: String },

    showTest: { type: Boolean },

    product: { type: Object },
    productHandle: { type: String },
    selectedVariant: { type: Object },

    options: { type: Object },

    moneyFormat: { type: String },

    quantity: { type: Number },
    rules: { type: Array },
    rule: { type: Object },
    cart: { type: Object },

    availableSellingPlanGroups: { state: true },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },

    disableUrl: { type: Boolean },

    debug: { type: Boolean },

    bcPage: { state: true },
  }


  // BC30 FUNCTION


showBC30Popup(e) {
  if (e) { e.preventDefault(); e.stopPropagation(); }
  this.bcPage = 0;
  const overlay = this.renderRoot.querySelector('#bc30Popup');
  if (overlay) overlay.style.display = 'flex';
}

closeBC30Popup(e) {
  if (e) { e.preventDefault(); e.stopPropagation(); }
  const overlay = this.renderRoot.querySelector('#bc30Popup');
  if (overlay) overlay.style.display = 'none';
}

bcIsMobile() { return window.matchMedia('(max-width:480px)').matches }
bcPerView()  { return this.bcIsMobile() ? 2 : 4 }
bcPages()    { return Math.max(1, Math.ceil(this.bcGifts.length / this.bcPerView())) }

bcStep(delta, e) {
  if (e) { e.preventDefault(); e.stopPropagation(); }
  const pages = this.bcPages();
  this.bcPage = Math.min(Math.max(this.bcPage + delta, 0), pages - 1);
}

  static styles = [
    css`
      :host {
        width: 100%;
        max-width: 500px;
      }

      .skio-plan-picker {
        display: flex;
        gap: 1rem;
        padding: 0;
        border: 0;
        font-size: 15px;
        color: black;
        width: 100%;
        margin-bottom: 1rem;
        margin-top: 3rem;
        font-family: inherit;
      }

      #BC15TestContainer {
        display: block;
      }

      :host([layout='hidden']) .skio-plan-picker {
        display: none;
      }

      :host([layout='vertical']) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout='horizontal']) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        border: .5px solid #40685d;
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, transparent);
        color: var(--skio-group-text-color, #000);
      }

      .group-container--selected {
        border-width: 2px;
        border-color: var(--skio-group-border-selected-color, #333);
        background-color: var(--skio-group-background-selected-color, transparent);
        color: var(--skio-group-text-selected-color, #000);
        font-weight:700 !important;
      }

      .group-container--last {
        order: 1;
      }

      :host([layout='horizontal']) .group-container {
        width: calc(50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px)));
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

      .group-input:focus-visible ~ .group-label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 10px;
        cursor: pointer;
      }

      .group-topline {
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: flex-start;
    gap: 8px;
      }

      @media (min-width: 1024px) {
        .bc15-price-main-container {
            margin-left: 50px;
        }
      }


      .group-container--selected .group-topline {
        font-weight: 700;
      }

      :host([layout='horizontal']) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      .skio-radio__container {
        display: flex;
        color: var(--skio-group-border-color, #333);
      }

      .group-container--selected .skio-radio__container {
        color: var(--skio-group-border-selected-color, #333);
      }

      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 0.75;
        transform: scale(1);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(1);
      }

      .skio-price {
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: center;
        text-align: right;
        gap: 4px;

        line-height: 1;

        margin-left: auto;
        vertical-align: middle;

        font-weight: 600;
      }

      .skio-price .per-cup-price{
      font-size:13px !important;
       font-weight: 600 !important;
       text-align: right !important;
      }

      .skio-price s {
        font-size: 13px;

        font-weight: 400;
        opacity: 0.75;
      }

      :host([layout='horizontal']) .skio-price {
        text-align: center;
        margin-right: auto;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: auto;
        max-height: 1000px;
        transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-content.margin-left {
        margin-left: 25px;
      }

      .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: #000;
      }

      :host([layout='horizontal']) .group-content {
        width: 100%;
      }

      /* Hide frequency if not selected */
      .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      :host([layout='horizontal']) .group-container:not(.group-container--selected) + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .group-left {
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex: 1;
        min-width: 0;
      }

      .group-title {
        width: 100%;
        max-width: 100%;   /* was 50% */
        line-height: 1.4;
        font-weight: 600 !important;
      }

      :host([layout='horizontal']) .group-title {
        max-width: 100%;
      }

      .savings {
        color: var(--skio-discount-text-color, #fff);
      }

      .savings.bubble {
        position: absolute;
        top: -1.9em;
        right: 1em;
        padding: 0px 8px;
        background-color: var(--skio-discount-color, #0fa573);
        border: 1px var(--skio-discount-color, #0fa573) solid;
        border-radius: 4px;
        font-size: 12px;
        color: var(--skio-discount-text-color, #fff);
        white-space: nowrap;
      }

      .selling-plan-dropdown {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        margin-top: 5px;
        padding: 8px 30px 8px 10px;
        background-color: #f7f7f7;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px top 50%;
        background-size: 16px;
        border: 1px solid #ccc;
        border-radius: 2px;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .selling-plan-dropdown-label {
        color: #666666;
        font-weight: 500;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--skio-button-plan-selector-width, 20px), 1fr));
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type='radio'] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type='radio']:checked + label {
        border-color: #000;
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }

      .group-content-additional {
        margin-top: 5px;
        font-weight:400 !important; 
      }

      @media screen and (max-width: 767px) {
  .group-content-additional {
    margin-top: 10px;
    font-weight: 400 !important;
    font-size: 13px;
    margin-bottom: 5px;
  }
    .skio-price .per-cup-price {
    font-size: 11px !important;
 
}
}
        .group-content-additional ul{
list-style: none;
    padding: 0;
    margin: 0;
}

.group-content-additional ul li{
position: relative;
    padding-left: 1.75em;
}

.group-content-additional li::before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    top: 0.35em;
    left: 0;
    background-image:url(/cdn/shop/files/bc-tick-transparent.png?v=1733981170);
}

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: #000;
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: white;
        box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px) 10;
      }

      .setupMode:after {
        content: 'Setup Mode';
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }

 .bc15-main-container {
  display: none;
}

.bc15-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-top: 10px;
  position: relative;
  z-index: 2;
  max-width: 90%;
}

.bc15-gift-row {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  padding: 0 0px 10px;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  scrollbar-width: thin;
  -ms-overflow-style: none;
}

.bc15-gift-row::-webkit-scrollbar {
  height: 6px;
}

.bc15-gift {
  flex: 0 0 120px;
  max-width: 120px;
  padding: 8px;
  text-align: center;
  scroll-snap-align: start;
  word-wrap: break-word;
  white-space: normal;
}

.bc15-gift img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 5px;
}

.bc15-gift h2 {
  font-size: 14px;
  margin-bottom: 0px;
  margin-top: 0;
}

.bc15-gift-description {
  font-size: 12px;
  line-height: 1.2;
  margin: 2px 0;
  font-weight: 300;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
}

.bc15-price {
  text-decoration: line-through;
  font-weight: normal;
}

.bc15-free {
  font-weight: bold;
}

@media (max-width: 600px) {
  .bc15-title {
    font-size: 14px;
    max-width: 100%;
  }

  .bc15-gift {
    flex: 0 0 120px;
    max-width: 120px;
  }

  .bc15-gift img {
    width: 70px;
    height: 70px;
  }

  .bc15-gift-description {
    font-size: 11px;
    min-height: 70px;
  }
}

.group-container:not(.group-container--selected) .bc15-main-container {
  display: none;
}

 .savings.bubble {
	display: none;
 }
 
 .skio-price s {
	display: none;
 }
 
 .skio-price.bc15.per-cup-price {
	display: none;
 }

 .per-cup-price {
  display: none !important;
 }

 .bc15-bold-label {
    font-weight: bold;
    display: inline;
    white-space: nowrap;
    margin-top: 10px;
  }

  .bc15-per-cup-price {
    line-height: 1.2;
    font-size: 12px;
    width: 115px;
    display: flex;
    justify-content: end;
  }

  .bc15-price-main-container {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    gap: 3px;
    align-items:flex-end;
  }

   .sel-freq-container-skio {
    display: flex;
    align-items: center;
    margin-top: 1em;
    margin-bottom: -2em;
  }

  .sel-freq-container-skio .circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    box-sizing: border-box;
    background-color: black;
    color: white;
    border-radius: 50%;
    font-size: 14px;
    font-weight: bold;
    line-height: 1 !important;
    margin-right: 8px;
        letter-spacing: 0 !important;
    text-indent: 0;
    padding-top: 2px;
  }

  .sel-freq-container-skio .text {
    text-transform: capitalize;
    font-weight: 600;
    color: #000;
    font-size: 15px;
  }

  .bc30-red {
    background-color: red !important;
  }

  .bc30-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* ---------- POPUP (gifts carousel) ---------- */
  .bc30-popup {
    padding: 30px;
    border-radius: 8px;
    max-width: 900px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
    position: relative;
    background: white;
  }

  @media (max-width: 768px) {
    .bc30-popup {
      padding: 20px;
      margin: 16px !important;
    }
    #bc-gifts {
      border-radius: 10px !important;
    }
    .bc30-close-btn svg {
      width: 12px !important;
      height: 12px !important;
    }
    .bc30-close-btn {
      top: 2px !important;
      right: 2px !important;
    }
  }

  #bc-gifts {
    background: #EDF0ED !important;
  }

  .bc30-close-btn {
    position: absolute;
    top: 7px;
    right: 7px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }

  .bc15-main-container.bc30-popup-content {
    display: none;
  }

  .bc15-main-container.bc30-popup-content.active {
    display: block;
  }

  .bc30-included-btn {
    display: flex;
    padding: 8px 12px;
    text-decoration: underline;
    color: #000;
    flex-direction: row;
    justify-content: center;
    background: #B5D1BE;
    border: none;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    border-bottom-left-radius: 9px !important;
    border-bottom-right-radius: 9px !important;
  }

  .bc30-included-btn.show {
    display: flex;
  }

  .skio-radio__container.bc30 {
    color: #40685d;
  }

  .bc30-save15-label {
    color: #000000 !important;
  }

  .bc30-save15-label.show {
    display: inline;
  }

  .group-title {
    font-size: 16px !important;
  }

  .bc30-content-additional {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    margin-top: 6px;
    margin-left: -24px;   /* pulls checklist back to align with radio icon (18px icon + 8px gap) */
  }

  .bc30-check-item {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 400 !important;
    color: #000;
  }

  .bc30-check-item img {
    width: 11px;
    height: 11px;
    margin-right: 0.4rem;
  }

  .bc30-original-price {
    text-decoration: line-through;
    font-weight: 400 !important;
  }

  .skio-price.bc15.bc30 {
    all: unset !important;
    display: flex !important;
    flex-direction: row !important;
    font-size: 13px !important;
    gap: 3px !important;
    justify-content: end !important;
  }

  .discounted-price.bc30 {
    color: #d60f11 !important;
    font-weight: 600 !important;
  }

  .group-container--selected.bc30 {
    background-color: #eaf2ed !important;
    border-color: #40685d !important;
  }

  .bc15-title.bc30 {
    font-size: 18px !important;
  }

  .bc15-gift h2.bc30 {
    font-size: 16px !important;
  }

  .bc15-gift-description.bc30 {
    font-size: 14px !important;
  }

  .bc15-main-container.bc30 {
    background: #eaf2ed !important;
  }

  bc30-popup {
    background: #eaf2ed !important;
  }
.bc30-saving-label {
    font-size: 12px;
    font-weight: 600;
    color: #000000ff;
    text-align: right;
    background: #D98278;
    color: white;
    width: fit-content;
    display: flex;
    margin: auto;
    margin-right: 0;
    padding: 2px 7px;
    border-radius: 4px !important;
    margin-bottom: 3px;
}
  .bc15-price-main-container {
    margin-right: 35px;
}
   .group-topline {
    margin-left: 16px;
}

   .one-time-sub .group-topline {
       align-items: center;
   }
       .group-content.margin-left, .one-time-sub .group-topline {
    margin-left: 16px;
}
    .skio-price {
    margin-right: 35px;
}
    .subscription-option-bc label.group-label {
    padding-top: 16px;
}

    /* ---------- collapsed / expanded states ---------- */

    .subscription-option-bc:not(.group-container--selected) .bc30-content-additional{
      display: none !important;
    }

      .group-container.bc30 {
      border: 1px solid #40685d !important;
    }

    .group-container--selected.bc30 {
      border: 2px solid #40685d !important;
      box-shaow: inset 0 0 0 0px #40685d;
    }


    /* ============================================================
       MOBILE LAYOUT — subscription tile
       Row 1: radio + title + price (single row)
       Row 2: tick checklist, full width
       "Saving £x.xx" pill is hidden on mobile
       Keep this block LAST so it wins over the flat rules above.
       ============================================================ */
    @media screen and (max-width: 767px) {
      /* flatten .group-left so title + checklist become siblings of the price */
      .subscription-option-bc .group-left {
        display: contents;
      }
       .group-content.margin-left, .one-time-sub .group-topline {
          margin-left: 0px;
        }
          .skio-price{
          margin-right:0;
          }
      .subscription-option-bc .group-topline {
        flex-wrap: wrap;
        align-items: flex-start;
        row-gap: 0;
        column-gap: 6px;
        margin-left: 0px !important;
        padding-right: 0px;
      }

      .subscription-option-bc .skio-radio__container.bc30 {
        order: 1;
        flex: 0 0 auto;
        margin-top: 2px;
      }

      .subscription-option-bc .group-title {
        order: 2;
        flex: 1 1 auto;
        width: auto;
        min-width: 0;
        line-height:1.6;
        font-size:14.5px !important;
      }
      .group-title{
       font-size:14.5px !important;
      }
      .bc30-check-item {
        font-size: 13px !important;
      }
      .subscription-option-bc .bc15-price-main-container {
        order: 3;
        flex: 0 0 auto;
        margin-left: auto !important;
        margin-right: 0px !important;
        align-items: flex-end;
        gap: 2px;
      }

      /* price and per-cup line stay on one line each, never push the row */
      .subscription-option-bc .skio-price.bc15.bc30 {
        flex-wrap: nowrap !important;
        white-space: nowrap;
      }

      .subscription-option-bc .bc15-per-cup-price {
        width: auto !important;
        white-space: nowrap;
        justify-content: flex-end;
      }

      /* hide the pink saving pill on mobile only */
     

      /* checklist drops to its own full-width row */
      .subscription-option-bc .bc30-content-additional {
        order: 4;
        flex: 0 0 100%;
        width: 100%;
        margin-top: -9% !important;
        margin-left: 4px !important; /* aligns ticks under the title text */
      }
    }

    @media(max-width:420px){
      .subscription-option-bc .bc30-content-additional {
        margin-top: -11% !important;
      }  
            .subscription-option-bc .bc30-content-additional {
        margin-top: -5% !important;
      }  
    }

    `,

    css`
      #bc-gifts *{box-sizing:border-box;margin:0;padding:0}
      @font-face {
        font-family: "Canela Trail";
        src: url("https://cdn.shopify.com/s/files/1/0975/5482/5557/files/Canela-Regular-Trial.otf?v=1776772434") format("opentype");
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: "Area Normal";
        src: url("https://cdn.shopify.com/s/files/1/0975/5482/5557/files/fonnts.com-Area_Normal_Regular.otf?v=1776777920") format("opentype");
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
      #bc-gifts{
        --juniper:#22372B; --fern:#516E5A; --sage:#AFCCB8; --mist:#D1E0D7;
        --bg:#EEF2EF; --name:rgba(22,31,40,.72); --muted:rgba(22,31,40,.60);
        --border:#AFCCB8; --line:rgba(34,55,43,.14); --thumb:#FFFFFF;
        --shadow-soft:0 10px 30px rgba(22,31,40,.06);
        color:var(--juniper); background:var(--bg);
        width:auto; padding:30px 16px 34px; border-radius:20px;
      }
      #bc-gifts .bc-viewport {
        overflow: hidden;
        cursor: grab;
        touch-action: pan-y;
      }
      #bc-gifts .bc-viewport.is-dragging {
        cursor: grabbing;
        user-select: none;
      }
      #bc-gifts .bc-track {
        display: flex;
        align-items: flex-start;
        transition: transform .45s cubic-bezier(.4,0,.2,1);
        will-change: transform;
      }
      #bc-gifts .bc-viewport.is-dragging .bc-track {
        transition: none;
      }
      #bc-gifts .bc-inner{max-width:720px;margin:0 auto}
      #bc-gifts .bc-h{font-weight:400;font-size:clamp(24px,3vw,28px);line-height:1.15;text-align:center;letter-spacing:.025em;color:var(--juniper);margin:0 0 15px;font-family: Canela Trail;}
      #bc-gifts .bc-sub{text-align:center;color:var(--muted);font-size:15px;line-height:1.45;margin:0 auto 20px;max-width:460px; font-family: AreaNormal;
    font-weight: 500;}
      #bc-gifts .bc-nav{position:relative;margin-bottom:22px}
      #bc-gifts .bc-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:36px;height:36px;border:1px solid var(--border);border-radius:50%;background:#fff;box-shadow:var(--shadow-soft);cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--juniper);transition:background .2s ease,opacity .2s ease,transform .1s ease}
      #bc-gifts #bcPrev{left:0}
      #bc-gifts #bcNext{right:0}
      #bc-gifts .bc-arrow:hover:not([disabled]){background:var(--mist)}
      #bc-gifts .bc-arrow:active{transform:translateY(-50%) scale(.94)}
      #bc-gifts .bc-arrow[disabled]{opacity:.35;cursor:default}
      #bc-gifts .bc-arrow svg{width:15px;height:15px}
      #bc-gifts .bc-month{flex:0 0 25%;min-width:0;padding:0 6px}
      #bc-gifts .bc-mlabel{text-align:center;font-size:12px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:var(--juniper);margin-bottom:14px; font-family:AreaNormal;}
      #bc-gifts .bc-item{display:flex;align-items:center;gap:10px;margin-bottom:14px;min-height:49px}
      #bc-gifts .bc-item:last-child{margin-bottom:0}
      #bc-gifts .bc-thumb{flex:0 0 auto;width:49px;height:49px;border-radius:50%;background:var(--thumb);background-size:cover;background-position:center;border:2px solid var(--border);box-shadow:var(--shadow-soft);overflow:hidden;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:rgba(34,55,43,.55)}
      #bc-gifts .bc-thumb--save{background:var(--mist);border-color:#AFCCB8;color:var(--juniper);letter-spacing:-.02em; font-weight: 600!important;}
      #bc-gifts .bc-txt{flex:1 1 auto;min-width:0;font-size:12px;line-height:1.3}
      #bc-gifts .bc-line{display:block;color:var(--name);font-size:11.5px;line-height:1.35;overflow-wrap:anywhere;margin-bottom:4px; font-family: AreaNormal; font-weight: 400; }
      #bc-gifts .bc-line:last-child{margin-bottom:0}
      #bc-gifts .bc-price{display:inline-block;text-decoration:line-through;color:rgba(22,31,40,.6);font-weight:700;font-size:11px;margin-right:4px}
      #bc-gifts .bc-free{color:var(--fern);font-weight:800;letter-spacing:.02em}
      #bc-gifts .bc-save{color:var(--juniper);font-weight:800;letter-spacing:.02em}
      #bc-gifts .bc-progress{position:relative;width:100%;height:36px;margin:0}
      #bc-gifts .bc-rail{position:absolute;top:50%;height:2px;transform:translateY(-50%);background:var(--line)}
      #bc-gifts .bc-fill{position:absolute;top:50%;height:2px;transform:translateY(-50%);background:var(--sage);transition:width .45s cubic-bezier(.4,0,.2,1)}
      #bc-gifts .bc-node{position:absolute;top:50%;width:11px;height:11px;border-radius:50%;transform:translate(-50%,-50%);background:#fff;border:2px solid var(--line);transition:background .3s ease,border-color .3s ease}
      #bc-gifts .bc-node.on{background:var(--fern);border-color:var(--fern)}
      #bc-gifts .bc-free { font-size: 10px !important; }
      @media (max-width:480px){
        #bc-gifts{padding:22px 6px 26px}
        #bc-gifts .bc-month{flex:0 0 50%;padding:0 4px}
        #bc-gifts .bc-arrow{width:30px;height:30px}
        #bc-gifts .bc-arrow svg{width:13px;height:13px}
        #bc-gifts .bc-progress{width:67%;margin-inline:auto}
        #bc-gifts .bc-nav{margin-inline:5px}
        #bc-gifts .bc-sub {max-width: 260px;}
      }
    `,
  ]

  constructor() {
    super()
    // Start - Debug Variables
    this.debug = this.debug || window?.Shopify?.designMode
    this.variantChanged = false
    // End - Debug Variables

    this.rules = []
    this.rule = null
    this.quantity = 1
    this.showDetailsHover = false

    // Start - BC30 test global var
    this.showTest = false; // Default: test component is hidden, css is not applied

    // Global function to toggle test component
    window.toggleBC30Test = (state) => {
      this.showTest = state;
      this.requestUpdate();
    };
    // End - BC30 test global var

    this.gifts = [
      { 
        month: 1, 
        items: `<div><span class="bc15-bold-label">FREE:</span> Barista Skills Course<br>(worth £99)</div>`, 
        price: "£99", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-1.jpg?v=1741605627" 
      },
      { 
        month: 2, 
        items: `<div><span class="bc15-bold-label">FREE:</span> Focus Elixir (10ml)</div>
                <div><span class="bc15-bold-label">FREE:</span> James' Coffee<br>& Mushroom Blueprint</div>`, 
        price: "£79", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-2.jpg?v=1741605627" 
      },
      { 
        month: 3, 
        items: `<div><span class="bc15-bold-label">FREE:</span> Performance Elixir (10ml)</div>
                <div><span class="bc15-bold-label">FREE:</span> Coffee<br>Depletes Minerals:<br>Restore What's Lost</div>`, 
        price: "£89", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-3.jpg?v=1741605627" 
      },
      { 
        month: 4, 
        items: `<div><span class="bc15-bold-label">FREE:</span> Tranquility Elixir (10ml)</div>
                <div><span class="bc15-bold-label">FREE:</span> New Method<br>to Mental Clarity</div>`, 
        price: "£89", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-4.jpg?v=1741605627" 
      },
      { 
        month: 5, 
        items: `<div><span class="bc15-bold-label">FREE:</span> Longevity Elixir (10ml)</div>
                <div><span class="bc15-bold-label">FREE:</span> James' Guide<br>to Removing Toxins</div>`, 
        price: "£69", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-5.jpg?v=1741605627" 
      },
      { 
        month: 6, 
        items: `<div><span class="bc15-bold-label">SAVE £1</span></div>
                <div><span class="bc15-bold-label">FREE:</span> Gut Elixir (10ml)</div>`, 
        price: "£119", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-6.jpg?v=1741605628" 
      },
      { 
        month: 7, 
        items: `<div><span class="bc15-bold-label">FREE:</span> Guide<br>to Sleep Deeper,<br>+ Stress Less</div>`, 
        price: "£69", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-7.jpg?v=1741605627" 
      },
      { 
        month: 12, 
        items: `<div><span class="bc15-bold-label">SAVE £2</span></div>
                <div><span class="bc15-bold-label">FREE:</span> Limited<br>Edition Coffee</div>
                <div><span class="bc15-bold-label">FREE:</span> Longevity<br>Blueprint (worth £99)</div>`, 
        price: "£99", 
        image: "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/subs-gift-month-12.jpg?v=1741605627" 
      }
    ];

    // ---- BC30 gifts carousel data (months 1–24) ----
    const IMG       = "https://cdn.shopify.com/s/files/1/0975/5482/5557/files/";
    const IMG_MONTH = "https://cdn.shopify.com/s/files/1/0660/8571/6215/files/";

    this.bcGifts = [
      { label:"MONTH 1",  items:[
          {gift:"Barista Course", price:"£10", img:IMG+"barista-skills-course_afe2429a-d72c-4600-82a6-bd80eb773a57.jpg"} ] },
      { label:"MONTH 2",  items:[
          {gift:"Lion's Mane Elixir", price:"£15", img:IMG+"lions-mane-mushroom-tincture-t_18af12f0-c6b2-403a-a99b-437728e4a022.webp"},
          {gift:"Mental Clarity Guide", price:"£10", img:IMG+"newmethodclairty_98a3b507-0a77-4351-9b47-fa9e577ff7bf.jpg"} ] },
      { label:"MONTH 3",  items:[
          {gift:"Hydration Guide", price:"£10", img:IMG+"Frame_1707479645.png"} ] },
      { label:"MONTH 4",  items:[
          {gift:"Chaga Elixir", price:"£15", img:IMG+"chaga-mushroom-tincture-best_249961e8-c20c-482a-86b3-ae6263998c30.jpg"},
          {gift:"Mushroom Blueprint Guide", price:"£10", img:IMG+"coffeeandmushroomblueprint_78a9828c-581f-4fab-a598-e461c9efa8e9.jpg"} ] },
      { label:"MONTH 5",  items:[
          {gift:"Cordyceps Elixir", price:"£15", img:IMG+"cordyceps-mushroom-tincture1_5fc403da-5947-41e7-b3de-a64d5dc766a1.jpg"} ] },
      { label:"MONTH 6",  items:[
          {gift:"Reishi Elixir", price:"£15", img:IMG+"reish-mushroom-tincture-1_62468bda-529d-4106-9d16-e6895aced0e4.jpg"},
          {gift:"Detox Guide", price:"£10", img:IMG+"removing-toxins_88b6f2ac-b405-471c-9e4e-71d2f29f2836.jpg"} ] },
      { label:"MONTH 8",  items:[
          {gift:"Lion's Mane Elixir", price:"£15", img:IMG+"lions-mane-mushroom-tincture-t_18af12f0-c6b2-403a-a99b-437728e4a022.webp"},
          {gift:"Stability Blend 250g", price:"£15", img:IMG+"stability-blend-thumb_daac6b23-4619-42bf-9394-308a720ed8af.webp"} ] },
      { label:"MONTH 12", items:[
          {gift:"Gold Blend 250g", price:"£15", img:IMG+"limited-ed-coffee_34ddae63-f6a1-440d-90c7-9bc89af6abb1.jpg"},
          {gift:"Longevity Guide", price:"£10", img:IMG+"longevity-blueprint_b8cee009-85d5-4ad7-8e6c-ff910c8e67b3.jpg"},
          {gift:"Rotate Espresso 250g", price:"£14.99", img:IMG+"rotate-espresso-thumb_794bb64f-6c49-40f3-bf82-218cacd18d36.webp"} ] },
      { label:"MONTH 14", items:[
          {gift:"Gift Voucher £10", price:"£10", img:IMG+"best-list-christmas-coffee-gifts.jpg"},
          {gift:"Sleep Guide", price:"£10", img:IMG+"sleepdeeper_stressless_9647aea1-5e74-452a-9484-389587797c17.jpg"} ] },
      { label:"MONTH 16", items:[
          {gift:"Calm Coffee 250g", price:"£15", img:IMG+"CalmCoffeeBagMockup1kg_1.jpg"} ] },
      { label:"MONTH 18", items:[
          {gift:"Darkfire Energy 250g", price:"£15", img:IMG+"darkfire-energy-dark-roast_dfe7a237-684c-4703-b9bf-1d1adc4c3091.webp"} ] },
      { label:"MONTH 24", items:[
          {gift:"Mystery Blend", price:"£15", img:IMG+"Frame_1707479646_1.png"},
          {gift:"Aurora Single Origin 250g", price:"£20.99", img:IMG+"esmerelda-single-origin-thumb_0dc8d506-6a81-4d4f-9b99-bd27196f8641.webp"}
           ] }
    ];

    this.bcPage = 0;

    this.numberElementsCount = 0;
    
  }

  async connectedCallback() {
    super.connectedCallback()
    this.bcResizeHandler = () => this.requestUpdate();

    this.log('Mounted')
    this.log('bc30' + this.showTest)

    this.numberElementsCount = [...document.querySelectorAll('.number')].filter(el => {
      return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
    }).length;

    if (this.productHandle) {
      this.loading = true
      this.fetchProduct(this.productHandle)
    }

    this.bindFormEvents()
    this.bindCartEvents()

    this.rules = await this.fetchRules()
    await this.getRule()

    window.addEventListener('resize', this.bcResizeHandler)

    //  Insert your BC30 check here:
    this.applyBC30TestStyles?.(); // Call your class toggling function
    
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.bcResizeHandler)
    super.disconnectedCallback()
  }

  // SECTION: Element Templates
  radioTemplate() {
    return html`
      <div class="skio-radio__container bc30">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1"></circle>
          <circle class="skio-radio" cx="12" cy="12" r="7" fill="currentColor"></circle>
        </svg>
      </div>
    `
  }

  sellingPlanDropdown(group) {
    return html`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(group).length == 1 ? 'selling-plan-dropdown--one' : ''}"
        @change=${e => {
          this.selectSellingPlan(e.target.value)
        }}
      >
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html` <option ?selected=${group.selected_selling_plan.id === selling_plan.id} value=${selling_plan.id}>${selling_plan.name}</option> `
            )
          : ''}
      </select>
    `
  }

  sellingPlanButtons(group) {
    return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${group
          ? this.getAvailableSellingPlans(group).map(
              selling_plan => html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${e => this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan === selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}"> ${selling_plan.name} </label>
              `
            )
          : ''}
      </fieldset>
    `
  }

  invalidIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D22B2B" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  validIcon() {
    return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0BDA51" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
  }

  setupMode() {
    return html`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">${this.product ? this.validIcon() : this.invalidIcon()} Product</div>

        <div class="detection">${this.selectedVariant ? this.validIcon() : this.invalidIcon()} Selected Variant</div>

        <div class="detection">${this.form ? this.validIcon() : this.invalidIcon()} Form</div>

        <div class="detection">${this.variantInput ? this.validIcon() : this.invalidIcon()} Variant Input</div>

        <div class="detection">
          ${this.variantChanged ? this.validIcon() : this.invalidIcon()} Variant Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small>If any of these don't pass please troubleshoot using our <a target="_blank" rel="noreferrer" href="https://integrate.skio.com/troubleshooting">troubleshooting guide</a>.</small>
      </div>
    `
  }

  groupContent(group) {
    return html`
      <div class="group-content ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector && this.options?.dropdownPosition == 'inside' ? 'margin-left' : ''}">
          <span class="selling-plan-dropdown-label">${this.additionalFrequencyLabel()}</span>
      ${this.options?.selector_type == 'dropdown' ? this.sellingPlanDropdown(group) : ''}
      ${this.options?.selector_type == 'button' ? this.sellingPlanButtons(group) : ''}
    </div>
  `
  }

  BC15Test() {
    return html`
      <div class="bc15-main-container">
        <h1 class="bc15-title">And get 16+ Gifts for 12 months →</h1>
        <div class="bc15-gift-row">
          ${this.gifts.map(gift => html`
            <div class="bc15-gift bc15-month-${gift.month}">
              <img src="${gift.image}" alt="Gift Image">
              <h2>Month ${gift.month}</h2>
              <div class="bc15-gift-description">
                ${unsafeHTML(gift.items)}
              </div>
            </div>
          `)}
        </div>
      </div>
    `;
  }
  
  // BC30 ADDITIONS

bc30additionalContentText() {
  return html`
    <div class="bc30-content-additional">
      <div class="bc30-check-item">
        <img src="https://cdn.shopify.com/s/files/1/0660/8571/6215/files/checkmark-green-no-bg.png?v=1752828900" alt="✓" width="20" height="20">
        <span>Free priority shipping £25+</span>
      </div>
      <div class="bc30-check-item">
        <img src="https://cdn.shopify.com/s/files/1/0660/8571/6215/files/checkmark-green-no-bg.png?v=1752828900" alt="✓" width="20" height="20">
        <span>Exclusive Monthly Gifts</span>
      </div>
      <div class="bc30-check-item">
        <img src="https://cdn.shopify.com/s/files/1/0660/8571/6215/files/checkmark-green-no-bg.png?v=1752828900" alt="✓" width="20" height="20">
        <span>Wellness Education Guides</span>
      </div>
      <div class="bc30-check-item">
        <img src="https://cdn.shopify.com/s/files/1/0660/8571/6215/files/checkmark-green-no-bg.png?v=1752828900" alt="✓" width="20" height="20">
        <span>Skip or Cancel Anytime </span>
      </div>
    </div>
  `;
}

// ---- drag / swipe on the gifts viewport ----
bc30PointerDown(e) {
  this.bc30DragStartX   = e.clientX;
  this.bc30DragCurrentX = e.clientX;
  this.bc30IsDragging   = true;

  const viewport = e.currentTarget;
  viewport.classList.add('is-dragging');
  viewport.setPointerCapture?.(e.pointerId);
}

bc30PointerMove(e) {
  if (!this.bc30IsDragging) return;
  this.bc30DragCurrentX = e.clientX;
}

bc30PointerUp(e) {
  if (!this.bc30IsDragging) return;

  const viewport = e.currentTarget;
  viewport.classList.remove('is-dragging');

  const distance  = this.bc30DragCurrentX - this.bc30DragStartX;
  const threshold = 50;

  this.bc30IsDragging = false;

  if (Math.abs(distance) < threshold) return;

  const pages = this.bcPages();

  if (distance < 0 && this.bcPage < pages - 1) {
    this.bcPage++;               // swipe left -> next
  } else if (distance > 0 && this.bcPage > 0) {
    this.bcPage--;               // swipe right -> previous
  }
}

// POPUP — 24-month gifts carousel
BC30PopupTest() {
  const pv     = this.bcPerView();
  const mobile = this.bcIsMobile();
  const total  = this.bcGifts.length;
  const pages  = this.bcPages();
  const page   = Math.min(Math.max(this.bcPage, 0), pages - 1);

  // slide by whole pages, clamped so the last view is always full
  const colPct    = 100 / pv;
  const maxOffset = Math.max(0, total * colPct - 100);
  const offset    = Math.min(page * 100, maxOffset);
  const frac      = pages === 1 ? 1 : page / (pages - 1);

  // desktop: one dot per visible column, at the column centres.
  // mobile : one dot per page across the full rail.
  let railStyle, fillStyle, nodes;
  if (mobile) {
    railStyle = 'left:0;right:0;';
    fillStyle = `left:0;width:${frac * 100}%;`;
    nodes = Array.from({ length: pages }, (_, i) => ({
      left: pages === 1 ? 0 : (i / (pages - 1)) * 100,
      on:   i <= page,
    }));
  } else {
    const firstPct = (0.5 / pv) * 100;
    const lastPct  = ((pv - 0.5) / pv) * 100;
    railStyle = `left:${firstPct}%;right:${100 - lastPct}%;`;
    fillStyle = `left:${firstPct}%;width:${frac * (lastPct - firstPct)}%;`;
    nodes = Array.from({ length: pv }, (_, i) => {
      const nodeFrac = pv === 1 ? 0 : i / (pv - 1);
      return { left: ((i + 0.5) / pv) * 100, on: nodeFrac <= frac + 0.001 };
    });
  }

  // one row inside a month column: a gift, or a recurring-discount badge
  const item = (it) => it.save
    ? html`
        <div class="bc-item">
          <span class="bc-thumb bc-thumb--save">${it.save}</span>
          <span class="bc-txt"><span class="bc-line bc-save">SAVE ${it.upTo ? 'UP TO ' : ''}${it.save}</span></span>
        </div>`
    : html`
        <div class="bc-item">
          <span class="bc-thumb" style=${it.img ? `background-image:url('${it.img}')` : ''}></span>
          <span class="bc-txt">
            <span class="bc-line">${it.gift}</span>
            <span class="bc-line">
              ${it.price ? html`<span class="bc-price">${it.price}</span>` : ''}<span class="bc-free">FREE</span>
            </span>
          </span>
        </div>`;

  return html`
    <div class="bc30-popup-overlay bc30" style="display:none;" id="bc30Popup"
         @click=${this.closeBC30Popup}>
      <div class="bc30-popup bc30" @click=${e => e.stopPropagation()}>
        <button type="button" class="bc30-close-btn bc30" @click=${this.closeBC30Popup}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#161F28"></path>
          </svg>
        </button>

        <div id="bc-gifts">
          <div class="bc-inner">
            <h2 class="bc-h">24 Months of Gifts to Unlock</h2>
            <p class="bc-sub">Free gifts, elixirs and education with every month subscribed.</p>

            <div class="bc-nav">
              <button type="button" class="bc-arrow" id="bcPrev" aria-label="Previous months"
                      ?disabled=${page === 0}
                      @click=${e => this.bcStep(-1, e)}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                     stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
              </button>

              <div class="bc-progress" aria-hidden="true">
                <div class="bc-rail" style=${railStyle}></div>
                <div class="bc-fill" style=${fillStyle}></div>
                ${nodes.map(n => html`<div class="bc-node ${n.on ? 'on' : ''}" style="left:${n.left}%"></div>`)}
              </div>

              <button type="button" class="bc-arrow" id="bcNext" aria-label="Next months"
                      ?disabled=${page >= pages - 1}
                      @click=${e => this.bcStep(1, e)}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                     stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
              </button>
            </div>

            <div
              class="bc-viewport"
              @pointerdown=${this.bc30PointerDown}
              @pointermove=${this.bc30PointerMove}
              @pointerup=${this.bc30PointerUp}
              @pointercancel=${this.bc30PointerUp}
            >
              <div class="bc-track" style="transform:translateX(-${offset}%)">
                ${this.bcGifts.map(m => html`
                  <div class="bc-month">
                    <div class="bc-mlabel">${m.label}</div>
                    ${m.items.map(item)}
                  </div>`)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}


  showDetails() {
    return html`
      <details class="skio-details" @mouseover=${e => this.detailsMouseover()} @mouseleave=${e => this.detailsMouseleave()}>
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            How do subscriptions work?
          </span>
        </summary>
        <div class="skio-details--content">
          <ul>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it's not for you</small>
              </div>
            </li>
          </ul>
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

            <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
              Powered by
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black" />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `
  }

  // !SECTION: Element Templates

  render() {
    if (!this.viable() || this.options?.layout === 'hidden') {
      return this.debug ? this.setupMode() : ''
    }
 
    this.updateExternalPrice()
    if (this.selectedVariant.selling_plan_allocations.length === 0 && !this.options?.show_without_subscription) {
      return this.debug ? this.setupMode() : ''
    }

    return html`
      ${this.debug ? this.setupMode() : null}

      <div class="sel-freq-container-skio">
        <span class="circle">${this.numberElementsCount + 1}</span><span class="text">Select Purchase Type</span>
      </div>
      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-plan-picker-legend">
        <legend id="skio-plan-picker-legend" class="${!this.options?.show_legend ? 'sr-only' : ''}">${unsafeHTML(this.options?.legend_content)}</legend>

        ${!this.product.requires_selling_plan
          ? html`
                <div
                  class="group-container
                        ${this.selectedSellingPlanGroup == null ? 'group-container--selected' : ''} 
                        ${!this.options?.onetime_first ? 'group-container--last' : ''}
                       bc30"
                  @click=${() => this.selectSellingPlanGroup(null)}
                >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${() => this.selectSellingPlanGroup(null)}
                />

                <label class="group-label one-time-sub" for="one-time-${this.key}" style="
    height: 2em;
    justify-content: center;
"> 
        ${this.showPerPriceinVariant()}

                  <div class="group-topline">
                    ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                    <div class="group-title">${this.options?.onetime_title ? this.options?.onetime_title : 'One time purchase'}</div>

                    <div class="skio-price" aria-live="polite">
                      ${this.options?.show_compare_price && this.pricePlan() > this.selectedVariant.price
                        ? html`<s aria-hidden="true">${this.money(this.pricePlan())}</s>`
                        : ''}
                      ${this.money(this.selectedVariant.price)}
                    </div>
                  </div>
                </label>
              </div>
            `
          : ''}
        ${this.availableSellingPlanGroups?.length
          ? this.availableSellingPlanGroups.map(
              (group, index) => html`
                <div class="group-container bc30 subscription-option-bc ${this.selectedSellingPlanGroup == group ? 'group-container--selected' : ''}">
                ${this.discountText(group.selected_selling_plan)
                          ? html` <span class="savings ${this.options?.discount_style}"> ${this.discountText(group.selected_selling_plan)} </span> `
                          : html``}
                  <input
                    id="group-${index}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    @change=${() => this.selectSellingPlanGroup(group)}
                    ?checked=${this.selectedSellingPlanGroup == group}
                  />
          ${(group.name ==='Prepaid')?(document.querySelector('skio-plan-picker').style.display = 'none'):''}
                <label class="group-label" for="group-${index}-${this.key}">
                    <div class="group-topline">
                      ${this.options?.layout == 'horizontal' ? '' : this.options?.show_radio_selector ? this.radioTemplate() : ''}

                      <div class="group-left">
                        <div class="group-title">
                          ${group.name !== 'Prepaid' && this.options?.subscription_title
                            ? this.options?.subscription_title
                            : group.name == 'Prepaid' && this.options?.prepaid_title
                            ? this.options?.prepaid_title
                            : group.name}
                        <span class="bc30-save15-label">15%</span>
                        </div>
                        ${this.bc30additionalContentText()}
                      </div>

                      <div class="bc15-price-main-container">
                      <div class="skio-price bc15 bc30" aria-live="polite">
                        ${this.options?.show_compare_price &&
                        (this.pricePlan() > this.selectedVariant.price || this.selectedVariant.price > this.price(group.selected_selling_plan, false))
                          ? html`<s aria-hidden="true">${this.money(this.pricePlan())}</s>`
                          : ''}
                        <span class="discounted-price bc30">
                        ${this.price(group.selected_selling_plan)}
                        </span>
                        /mo <span class="bc30-original-price">${this.money(this.selectedVariant.price)}</span>
                    
                        ${(this.getValue(this?.selectedVariant?.option1, this.price(group.selected_selling_plan, false)))?
                        html`<span class="per-cup-price">Only ${ this.getValue(this?.selectedVariant?.option1, this.price(group.selected_selling_plan, false))} per cup </span>`:''
                        }
                       
                      </div>
                      ${(this.selectedVariant.price - this.price(group.selected_selling_plan, false)) > 0
                      ? html`<div class="bc30-saving-label">Saving ${this.money(this.selectedVariant.price - this.price(group.selected_selling_plan, false))}</div>`
                      : ''}
                      ${(this.getValue(this?.selectedVariant?.option1, this.price(group.selected_selling_plan, false)))?
                      html`<div class="bc15-per-cup-price">Only ${ this.getValue(this?.selectedVariant?.option1, this.price(group.selected_selling_plan, false))} per cup </div>`:''
                      }
                      </div>
                    </div>

                   ${this.options?.layout == 'vertical' &&
  this.options?.dropdownPosition == 'inside'
  ? html`
      ${this.BC30PopupTest()}
    `
  : ''}

${this.options?.layout == 'vertical' &&
  this.options?.dropdownPosition == 'inside'
  ? this.groupContent(group)
  : ''}

                  </label>                  
                 
                    <div 
                      class="bc30-included-btn show" 
                      @click=${e => this.showBC30Popup(e)}>
                      Your Free Monthly Gifts →
                    </div>
                </div>
                ${this.selectedSellingPlanGroup == group ? (this.options?.layout == 'horizontal' || this.options?.dropdownPosition == 'underneath' ? this.groupContent(group) : '') : ''}
              `
            )
          : ''}
        ${this.options?.show_details == true ? this.showDetails() : ''}
         ${this.updateExternalPrice()}
      </fieldset>
    `
  }

  async fetchRules() {
    if (sessionStorage.getItem('skio-discount-rules')) {
      return JSON.parse(sessionStorage.getItem('skio-discount-rules'))
    } else {
      const rules = await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`)
        .then(response => response.json())
        .then(response => {
          return response.rules.filter(rule => rule.type !== 'surpriseDelight').sort((a, b) => a.minQuantityToDiscount - b.minQuantityToDiscount)
        })

      sessionStorage.setItem('skio-discount-rules', JSON.stringify(rules))
      return rules
    }
  }
 

  eligibleItemCount(rule) {
    const eligibleQuantity = rule?.productVariantIds.some(gid => gid.includes(this.selectedVariant.id)) ? this.quantity : 0

    if (!this.cart?.items) return eligibleQuantity

    const cartItems = Number(
      this.cart?.items.reduce(
        (aggregate, item) =>
          rule?.productVariantIds.some(gid => gid.includes(item.id) && item.selling_plan_allocation && gid.includes(this.selectedVariant.id)) ? aggregate + item.quantity : aggregate,
        0
      )
    )

    return cartItems + eligibleQuantity
  }

  getRule() {
    let largestMinQuantity = {
      value: -1,
      index: -1,
    }

    this.rules.forEach((rule, index) => {
      if (rule.code && largestMinQuantity.value < rule.minQuantityToDiscount) {
        if (rule.minQuantityToDiscount <= this.eligibleItemCount(rule)) {
          largestMinQuantity.value = rule.minQuantityToDiscount
          largestMinQuantity.index = index
        }
      }
    })

    this.rule = largestMinQuantity.index > -1 ? this.rules[largestMinQuantity.index] : null
  }

  bindCartEvents() {
    document.addEventListener('CartUpdated', event => {
      this.cart = event.detail
    })
  }

  bindFormEvents() {
    this.form = document.querySelector(`#${this.options?.form_id}`) || this.closest('form[action*="/cart/add"]')

    if (!this.form) {
      return
    }

    this.variantInput = this.form.querySelector('[name="id"]')

    if (this.variantInput) {
      if (this.product) {
        const currentVariant = this.product.variants.find(variant => variant.id == this.variantInput.value)
        if (currentVariant) {
          this.selectedVariant = currentVariant
          this.updateExternalPrice()
        }
      }

      this.variantInput.addEventListener('change', e => {
        this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value)
        this.variantChanged = true
        
        this.updateExternalPrice()
      })
    }

    const $quantityInput = this.form.querySelector('[name="quantity"]')

    if ($quantityInput) {
      this.quantity = Number($quantityInput.value)
      $quantityInput.addEventListener('input', () => {
        this.quantity = Number($quantityInput.value)
      })
    }

    //check for the [name="properties[Full Name]"] and [name="properties[Email]"]
    let fullNameInput = this.form.querySelector('[name="properties[Full Name]"]');
    let emailInput = this.form.querySelector('[name="properties[Email]"]');
    const skio = this;
    if (fullNameInput && emailInput) {
      //we can perform our input inject and watch for changes to their inputs
      fullNameInput.addEventListener("change", function() {
        let prepaidGiftMessageInput = skio.form.querySelector('[name="properties[_prepaidGiftMessage]"]');
        if (prepaidGiftMessageInput) {
          prepaidGiftMessageInput.value = fullNameInput.value;
        } else {
          prepaidGiftMessageInput = document.createElement('input');
          prepaidGiftMessageInput.type = "hidden";
          prepaidGiftMessageInput.name = "properties[_prepaidGiftMessage]";
          prepaidGiftMessageInput.value = fullNameInput.value;
          skio.form.append(prepaidGiftMessageInput);
        }
      });

      emailInput.addEventListener("change", function() {
        let prepaidGiftEmailInput = skio.form.querySelector('[name="properties[_prepaidGiftEmail]"]');
        if (prepaidGiftEmailInput) {
          prepaidGiftEmailInput.value = emailInput.value;
        } else {
          prepaidGiftEmailInput = document.createElement('input');
          prepaidGiftEmailInput.type = "hidden";
          prepaidGiftEmailInput.name = "properties[_prepaidGiftEmail]";
          prepaidGiftEmailInput.value = emailInput.value;
          skio.form.append(prepaidGiftEmailInput);
        }
      });
    }

  }

  detailsMouseover() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (!details.hasAttribute('open') && this.showDetailsHover == false) {
      summary.click()
      this.showDetailsHover = true
    }
  }

  detailsMouseleave() {
    let details = this.renderRoot.querySelector('.skio-details')
    let summary = this.renderRoot.querySelector('.skio-details summary')
    if (details.hasAttribute('open') && this.showDetailsHover == true) {
      summary.click()
      this.showDetailsHover = false
    }
  }

  updated(changed) {
    this.updateExternalPrice()
    if (!this.viable()) return

    if (changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group =>
          selling_plan_group.app_id === 'SKIO' && !selling_plan_group.name.toLowerCase().includes('hidden-') && !selling_plan_group.name.toLowerCase().includes('dynamic box subscription')
      )

      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = filteredSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
        )
      )

      if (this.options?.combine_groups) {
        this.availableSellingPlanGroups = [
          {
            name: this.options?.combined_group_name,
            selling_plans: this.availableSellingPlanGroups.flatMap(group => group.selling_plans),
            id: 'combined_group',
            app_id: 'SKIO',
          },
        ]
      }

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length) {
        const url = new URL(window.location.href)
        const urlSelectedSellingPlanId = url.searchParams.get('selling_plan')

        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach(group => {
          const availableSellingPlans = this.getAvailableSellingPlans(group)

          const urlSelectedSellingPlan = availableSellingPlans.find(plan => plan.id == urlSelectedSellingPlanId)
          const nameSelectedSellingPlan = availableSellingPlans.find(plan => plan.name === this.selectedSellingPlan?.name)
          const defaultSellingPlan =
            this.options?.default_subscription && this.options.default_subscription.trim() !== ''
              ? availableSellingPlans.find(plan => plan.name.toLowerCase().includes(this.options.default_subscription.toLowerCase()))
              : null

          group.selected_selling_plan = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan || availableSellingPlans[0]

          const isAnyPlanSelected = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan

          group.selected = !!isAnyPlanSelected
        })

        if ((!this.variantChanged && this.options?.start_onetime == false) || this.product.requires_selling_plan == true || urlSelectedSellingPlanId || this.selectedSellingPlan) {
          let selectedSellingPlanGroup = this.availableSellingPlanGroups.find(group => group.selected) || this.availableSellingPlanGroups[0]
          let selectedSellingPlanId = selectedSellingPlanGroup.selected_selling_plan.id
          this.selectSellingPlan(selectedSellingPlanId)
        } else {
          this.selectSellingPlanGroup(null)
        }
      } else {
        this.selectSellingPlanGroup(null)
      }
    }

    if (changed.has('selectedSellingPlan')) {
      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this.selectedSellingPlan,
          key: this.key,
        },
      })

      this.dispatchEvent(event)

      this.dispatchEvent(
        new CustomEvent('change', {
          detail: { value: this.selectedSellingPlan?.id },
        })
      )
    }

    this.updateForm()
    this.updateExternalPrice()

    if (!this.disableUrl) {
      this.updateURLParams()
    }

    if (changed.has('quantity')) {
      this.getRule()
    }

    if (changed.has('cart')) {
      this.getRule()
    }

    this.updateExternalElements()
  }

  updateExternalElements() {
    document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(el => {
      el.innerHTML = this.price(this.selectedSellingPlan)
    })

    document.querySelectorAll(`[skio-subscription-content]`).forEach(el => {
      el.style.display = this.selectedSellingPlan ? 'block' : 'none'
    })
  }

  // SECTION: Utility Functions
  log(...args) {
    args.unshift(`%c[skio plan picker][${this.key}]`, 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error(...args) {
    args.unshift(`%c [skio plan picker][${this.key}]`, 'color: #ff0000')
    console.error.apply(console, args)
  }

  appendOrdinalSuffix(num) {
    const j = num % 10,
      k = num % 100
    if (j == 1 && k != 11) {
      return num + 'st'
    }
    if (j == 2 && k != 12) {
      return num + 'nd'
    }
    if (j == 3 && k != 13) {
      return num + 'rd'
    }
    return num + 'th'
  }

  viable() {
    const errors = []

    const sellingPlanInput = this.querySelector('input[name=selling_plan]')
    if (!sellingPlanInput) {
      errors.push('Missing selling plan input')
    }

    if (!this.product) {
      errors.push('No product found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.selectedVariant) {
      errors.push('No variant found. Please pass a product or productHandle to the skio-plan-picker component.')
    }
    if (!this.form) {
      errors.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".')
    }
    if (!this.variantInput) {
      errors.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"')
    }

    if (errors.length == 0) return true

    this.error('Errors', errors)
    return false
  }

  getAvailableSellingPlans(group) {
    let availableSellingPlans = group.selling_plans.filter(selling_plan =>
      this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id)
    )

    return availableSellingPlans
  }

  // !SECTION: Utility Functions

  // Update selected selling plan group; called on click of group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group
    this.selectedSellingPlan = group?.selected_selling_plan
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan_id) {
    const selectedGroup = this.availableSellingPlanGroups.find(group => group.selling_plans.some(plan => plan.id == selling_plan_id))
    const selectedSellingPlan = selectedGroup.selling_plans.find(plan => plan.id == selling_plan_id)

    selectedGroup.selected_selling_plan = selectedSellingPlan
    this.selectedSellingPlanGroup = selectedGroup
    this.selectedSellingPlan = selectedSellingPlan

  }
// updated 
  updateExternalPrice() {
    const available = this.selectedVariant?.available

    const label = available
      ? (this.selectedSellingPlan
          ? `Add to cart - ${this.price(this.selectedSellingPlan)}`
          : `Add to cart - ${this.money(this.selectedVariant.price)}`)
      : (this.options?.soldOut || 'Sold out')

    document.querySelectorAll(this.options?.external_price_selector).forEach(el => {
      el.innerHTML = label
    })

    const btn = this.form?.querySelector('#AddToCart, [data-product-add-to-cart-button]')
    if (btn) {
      btn.disabled = !available
      const btnText = btn.querySelector('#buy-btn-txt')
      if (btnText) btnText.textContent = available ? btnText.textContent : (this.options?.soldOut || 'Sold out')
    }
  }
// updated 
  additionalFrequencyLabel() {
    if (!this.options?.additional_frequency_label || this.options?.additional_frequency_label == '') return

    return unsafeHTML(this.options?.additional_frequency_label)
  }

  additionalContentText() {
    if (!this.options?.additional_subscription_content || this.options?.additional_subscription_content == '') return

    return html`
      <div class="group-content-additional">
        ${unsafeHTML(
          this.options?.additional_subscription_content
            .replaceAll(
              '[discount]',
              this.options?.discount_format === 'absolute' ? this.money(this.discount(this.selectedSellingPlan).absolute) : this.discount(this.selectedSellingPlan).percent + '%'
            )
            .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(this.selectedSellingPlan) || '')
        )}
      </div>
    `
  }
  
  // SECTION: Discount Functions
  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
showPerPriceinVariant(){
  let subSelected= this.selectedSellingPlanGroup
  if(subSelected){
    document.querySelectorAll('.block-swatch__item .subscribe_save').forEach(element => {
      element.style.display = 'block';
  });
  document.querySelectorAll('.block-swatch__item .one_time_purchase').forEach(element => {
    element.style.display = 'none';
});
  }else{
    document.querySelectorAll('.block-swatch__item .subscribe_save').forEach(element => {
      element.style.display = 'none';
  });
  document.querySelectorAll('.block-swatch__item .one_time_purchase').forEach(element => {
    element.style.display = 'block';
});
  }
  
}

  pricePlan(){
    let base_variant = this.product.variants[3] ||this.product.variants[0];
    let base_price = base_variant.price
    let base_size = this.IntegerConverter(base_variant.title)
    let current_variant = this.selectedVariant;
    let current_size = this.IntegerConverter(current_variant.title)
    let multiplier = current_size / base_size;
    let calculatedPrice = base_price * multiplier;
    return calculatedPrice;
  }
  IntegerConverter(text){
    let sizeNum= text?.match(/\((\d+)/)
    if(sizeNum)
      return parseInt(sizeNum[[1]]); // when there is ()
    else {
      let m = text.match(/\b\d+\b/)[0] // when there is normal text in title 
      return parseInt(m)
    }
      
  }
  discountText(selling_plan) {
    
    let base_variant = this.product.variants[3]||this.product.variants[0];
    let base_price = base_variant.price/100
    let base_size = this.IntegerConverter(base_variant.title)
    let current_variant = this.selectedVariant;
    let current_size = this.IntegerConverter(current_variant.title)
    let multiplier = current_size / base_size;
    let calculatedPrice = base_price * multiplier;
    let selectedPrice = this.price(selling_plan, false)/100
    let percent_discount = (((calculatedPrice - selectedPrice)/calculatedPrice)*100).toFixed(0); 
    const discount = {
      percent: percent_discount,
      amount: calculatedPrice - selectedPrice,
      absolute: selectedPrice
    }
    const hasInvalidDiscount = Object.values(discount).some(value => value === 0 || value === Infinity || value.toString().includes('-'))

    if (hasInvalidDiscount) {
      return '' // Return empty if any invalid condition is met
    } else {
      return unsafeHTML(
        this.options?.discount_text
          .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
          .replaceAll('[future_price_adjustments]', this.postCheckoutDiscountsText(selling_plan) || '')
      )
    }
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: 0, amount: 0 }
    return this.getDiscountFromPriceAdjustment(selling_plan, selling_plan.price_adjustments[0])
  }

  postCheckoutPriceAdjustments(selling_plan) {
    const { price_adjustments } = selling_plan
    const postCheckoutPriceAdjustments = price_adjustments.filter(({ position }) => position !== 1)
    const discounts = postCheckoutPriceAdjustments.map(price_adjustment => this.getDiscountFromPriceAdjustment(selling_plan, price_adjustment))
    return discounts
  }

  postCheckoutDiscountsText(sellingPlan = this.selectedSellingPlan) {
    if (!sellingPlan || !this.options?.future_price_adjustments_text || this.future_price_adjustments_text == '') return

    const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(sellingPlan)
    if (!postCheckoutPriceAdjustments.length) return

    return postCheckoutPriceAdjustments.map((discount, index) =>
      this.options?.future_price_adjustments_text
        .replaceAll('[discount]', this.options?.discount_format === 'absolute' ? this.money(discount.absolute) : discount.percent + '%')
        .replaceAll('[order_count]', index + 1)
        .replaceAll('[order_count_ordinal]', this.appendOrdinalSuffix(index + 1))
    )
  }

  getDiscountFromPriceAdjustment(selling_plan, price_adjustment) {
    const discount = {
      percent: 0,
      amount: 0,
      absolute: 0,
    }

    let multiplier = 1

    let sellingPlanGroup = this.product.selling_plan_groups.find(group => group.selling_plans.some(plan => plan.id == selling_plan.id))

    if (sellingPlanGroup?.name === 'Prepaid') {
      const str = selling_plan.name
      const intervalDate = /\b\d+\s*(days|weeks|months|years)\b/gi
      const intervalDateMatches = str.match(intervalDate)

      if (intervalDateMatches?.length) {
        const intervals = intervalDateMatches[0].match(/\d+/g)
        multiplier = intervals[0] / (intervals[1] || 1)
        multiplier = multiplier > 1 ? multiplier : 1
      }
    }

    const price = this.selectedVariant.price
    const compareAtPrice = this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > price ? this.selectedVariant.compare_at_price : price

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = price_adjustment.value
        discount.absolute = Math.round((price * price_adjustment.value) / 100.0)
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = Math.round(((price_adjustment.value * 1.0) / price) * 100.0)
        discount.absolute = price_adjustment.value
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = Math.round((((compareAtPrice * multiplier - price_adjustment.value) * 1.0) / (compareAtPrice * multiplier)) * 100.0)
        discount.absolute = compareAtPrice * multiplier - price_adjustment.value
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }

  /**
   * Formats a number of cents into a currency string using Shopify format string.
   *
   * https://help.shopify.com/en/manual/international/pricing/currency-formatting#currency-formatting-options
   *
   * Originally from: https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
   *
   * @param cents - The number of cents to format.
   * @param formatString - The format string to use.
   * @returns The formatted currency string.
   */
  money(cents, formatString = this.moneyFormat) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) {
        return '0'
      }

      const numString = (number / 100.0).toFixed(precision)
      const parts = numString.split('.')
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      const cents = parts[1] ? decimal + parts[1] : ''
      return dollars + cents
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(cents, 2)
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0)
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',')
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',')
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.')
        case 'amount_no_decimals_with_space_separator':
          return formatWithDelimiters(cents, 0, ' ')
        case 'amount_with_space_separator':
          return formatWithDelimiters(cents, 2, ' ', ',')
        case 'amount_with_period_and_space_separator':
          return formatWithDelimiters(cents, 2, ' ', '.')
        default:
          return match
      }
    })
  }

  // !SECTION: Discount Functions
  getValue(option, price){
    const cups = option.match(/\((\d+)\s*cups\)/);

if (cups) {
  let numCups=Number(cups[1])
  let actualPrice = price/100;
  let perCupPrice= actualPrice/numCups
  let finalValue= perCupPrice.toFixed(2)
  return '£' + finalValue

} else {
}
  }
  price(selling_plan, formatted = true) {
    if (this.rule) {
      return formatted
        ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100))
        : this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100)
    }

    return formatted ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount) : this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]')

    if ($sellingPlan) {
      $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : ''
      $sellingPlan.dispatchEvent(new Event('change'))
    }
  }

  // SECTION: Additional Functionality
  updateURLParams() {
    const url = new URL(window.location.href)

    if (this.selectedSellingPlan) {
      url.searchParams.set('selling_plan', this.selectedSellingPlan.id)
      window.history.replaceState({}, '', url.href)
    } else {
      url.searchParams.delete('selling_plan')
      window.history.replaceState({}, '', url.href)
    }
  }

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    // added 
        if (!this.selectedVariant?.available) {
      this.error(`Blocked add-to-cart: variant ${this.selectedVariant?.id} is unavailable`)
      return
    }
    // added 
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && {
          selling_plan: this.selectedSellingPlan?.id,
        }),
      },
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items,
      }),
    })
      .then(response => response.json())
      .then(response => {
        this.log('Added item to cart: ', response)
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key,
          },
        })

        this.dispatchEvent(event)
      })
      .catch(error => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = handle => {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }
  // !SECTION: Additional Functionality
}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPicker)
}

if (window) window.SkioPlanPicker = SkioPlanPicker